// Item.tsx
import { useTranslation } from 'react-i18next'
import { ReactSVG } from 'react-svg'

import { CustomerPaymentMethodItem } from '@features/payment/lib/types'

import Radio from '@shared/ui/radio'

import styles from './styles.module.scss'

type Props = {
  data: CustomerPaymentMethodItem | null;
  isSelected: boolean;
  onSelect: () => void;
};

export default function Item ({ data, isSelected, onSelect }: Props) {
  const isNewCard = data === null
  const { t: to } = useTranslation('order')
  const iconSrc = isNewCard
    ? '/icons/payments/crosshair.svg'
    : `/icons/${
      {
        master: 'payments/mastercard',
        visa: 'payments/visa',
      }[data?.card ?? ''] ?? 'card'
    }.svg`

  return (
    <div className={styles.item} onClick={onSelect} role="button" tabIndex={0}>
      <ReactSVG className={styles.item__icon} src={iconSrc} wrapper="span" />
      <p>{isNewCard ? to('new_card') : `${to('card')} ****${data?.last}`}</p>
      <Radio checked={isSelected} onChange={onSelect} />
    </div>
  )
}
